module.exports = __webpack_public_path__ + "static/img/jd_bg_img.281fe618.png";